import { render, staticRenderFns } from "./FaturasBoletos.vue?vue&type=template&id=5cac1cd5&scoped=true"
import script from "./FaturasBoletos.vue?vue&type=script&lang=js"
export * from "./FaturasBoletos.vue?vue&type=script&lang=js"
import style0 from "./FaturasBoletos.vue?vue&type=style&index=0&id=5cac1cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac1cd5",
  null
  
)

export default component.exports